import Vue from "vue";

export default {
  transmitPickupServiceRequest: function ({ commit, state, rootState }, data) {
    commit("REQUEST_TRANSMIT_PICKUP_SERVICE");
    const { emailTo = "" } = data;
    const { emailSubject = "" } = data;
    const { emailMessage = "" } = data;

    if (
      !rootState.session.authResult.checkin ||
      !rootState.session.authResult.checkin[0] ||
      !rootState.session.authResult.checkin[0].name
    ) {
      commit("FAILED_REQUEST_TRANSMIT_PICKUP_SERVICE");
      return;
    }

    const transmitPickupServiceRequest = Vue.onesocket.send({
      function: "sendEMail",
      module: "SQMOD_EMail",
      data: {
        email_to: emailTo,
        email_subject: emailSubject,
        email_message: emailMessage,
      },
      onMessage: function (data) {
        clearTimeout(transmitTimeout);
        if (data.payload.status === "OK") {
          commit("SUCCESS_REQUEST_TRANSMIT_PICKUP_SERVICE");
        } else {
          commit("FAILED_REQUEST_TRANSMIT_PICKUP_SERVICE");
        }
      },
      onError: function (event) {
        clearTimeout(transmitTimeout);
        commit("FAILED_REQUEST_TRANSMIT_PICKUP_SERVICE");
      },
    });
    const transmitTimeout = setTimeout(function () {
      Vue.onesocket.clearMessages(transmitPickupServiceRequest);
      commit("FAILED_REQUEST_TRANSMIT_PICKUP_SERVICE");
    }, 30000);
  },
};
